
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";

import CurrencyCell from "../../../component/CurrencyCell";

const columns = [

  { field: "shop", label: "ALLOCATION HEAD", align: "left" },
  { field: "wo", label: "Workorder", align: "left" },
  { field: "dl", label: "DIRECT LABOUR", align: "right" },
  { field: "ds", label: "DIRECT STORE", align: "right" },
  { field: "ocl", label: "ON COST LABOUR", align: "right" },
  { field: "ocs", label: "ON COST STORE", align: "right" },
  { field: "total", label: "Total", align: "right" },
 



];

export default function WGRTable({ rows }) {
  return (
    <TableContainer>
      <Table size="small">

        <TableHead>
          <TableRow>
            {columns.map((column) => (
              <TableCell
                key={column.field}
                align={column.align}
                sx={{
                  fontWeight: 700,
                  bgcolor: "grey.200",
                  whiteSpace: "nowrap",
                }}
              >
                {column.label}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>

        <TableBody>
          {rows.map((row, index) => {

            const dl = Number(row["DIRECT LABOUR"] || 0);
            const ds = Number(row["DIRECT STORE"] || 0);
            const ocl = Number(row["ON COST LABOUR"] || 0);
            const ocs = Number(row["ON COST STORE"] || 0);

            const total = dl + ds + ocl + ocs;

            return (
              <TableRow
                key={index}
                hover
                sx={{
                  "&:nth-of-type(even)": {
                    bgcolor: "grey.50",
                  },
                }}
              >

                <TableCell align="left">
                  {row.Allocation}
                </TableCell>

                <TableCell align="left">
                  {row.WORKORDER}
                </TableCell>

                <TableCell align="right">
                  <CurrencyCell
                    value={dl}
                  />
                </TableCell>

                <TableCell align="right">
                  <CurrencyCell
                    value={ds}
                  />
                </TableCell>

                <TableCell align="right">
                  <CurrencyCell
                    value={ocl}
                  />
                </TableCell>

                <TableCell align="right">
                  <CurrencyCell
                    value={ocs}
                  />
                </TableCell>

                <TableCell align="right">
                  <CurrencyCell
                    value={total}
                  />
                </TableCell>

              </TableRow>
            );
          })}
        </TableBody>

      </Table>
    </TableContainer>
  );
}

